//@flow
import React from 'react';
import classNames from 'classnames';
import rightWhite from 'assets/images/rightWhite.png';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  buttonName: string,
  className?: string,
  onClick?: () => void,
};

export const GetInTouch = (props: Props) => {
  const { buttonName, className, onClick } = props;
  const containerClassName = classNames('get-in-touch-mobile', className);
  return (
    <button onClick={onClick} type={'button'} className={containerClassName}>
      <span>{buttonName ? buttonName : 'GET IN TOUCH'}</span>
      {/*<img src={rightWhite} alt={'arrow-icon'} />*/}
    </button>
  );
};
